function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon - 24px",
  clipPath: "url(#clip0_14333_64254)"
}, React.createElement("path", {
  id: "Vector",
  d: "M9.66634 5.8335H5.49967C5.05765 5.8335 4.63372 6.00909 4.32116 6.32165C4.0086 6.63421 3.83301 7.05814 3.83301 7.50016V15.0002C3.83301 15.4422 4.0086 15.8661 4.32116 16.1787C4.63372 16.4912 5.05765 16.6668 5.49967 16.6668H12.9997C13.4417 16.6668 13.8656 16.4912 14.1782 16.1787C14.4907 15.8661 14.6663 15.4422 14.6663 15.0002V10.8335",
  stroke: "#F264D4",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  id: "Vector_2",
  d: "M8.83301 11.6668L17.1663 3.3335",
  stroke: "#F264D4",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  id: "Vector_3",
  d: "M13 3.3335H17.1667V7.50016",
  stroke: "#F264D4",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_14333_64254"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgViewDark = function SvgViewDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgViewDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view-dark.480d75d0.svg";
export { ForwardRef as ReactComponent };